import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {BUTTON_PRIMARY, SUCCESS} from '../assets/constants/Constants';
import {LOCAL_STORAGE, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS} from '../assets/constants/BrowserStorageKeys';
import {LOCKER_UNIT_SELECTION, OPEN_LOCKER} from '../assets/constants/PageList';
import {getSecureItemFromSpecificStorage} from '../lib/BrowserStorageAccessMiddleware';
import {reserveLocker} from '../api/api';
import {getPathForNextPage, verifyUserProximity} from '../lib/Utils';
import ButtonComponent from '../components/ButtonComponent';
import CircularProgressLoader from '../components/CircularProgressLoader';
import CustomDialog from '../components/CustomDialog';

const LockerUnitSelectionPage = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const [isLoading, setIsLoading] = useState(false);
    const { lockerBankId, assignmentSlug, userId, selectedLockerSize } = history.location?.state;
    const [selectedLockerUnit, setSelectedLockerUnit] = useState({id: null, door_no: ''});
    const [userProximityError, setUserProximityError] = useState('');
    const [isUserProximityErrorModalVisible, setIsUserProximityErrorModalVisible] = useState(false);
    // console.log('selected locker size: ', selectedLockerSize);

    const reserveSelectedLocker = async () => {
        setIsLoading(true);
        try {
            if (tenantAndAssignmentSettings?.is_geofencing) {
                const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
                const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
                const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
                const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
                // devConsoleLog('is user nearby locker bank: ', isUserNearbyLockerBank);
    
                if ( !isUserNearbyLockerBank.isNearby ) {
                    // setLoadingMessage('');
                    setIsLoading(false);
                    setUserProximityError(isUserNearbyLockerBank.message);
                    setIsUserProximityErrorModalVisible(true);
    
                    return;
                }
            }

            const reserveLockerResponse = await reserveLocker(assignmentSlug, lockerBankId, userId, selectedLockerSize.code, selectedLockerUnit.id);
            if (reserveLockerResponse.status === SUCCESS) {
                const lockerUnitDetails = {
                    ref_id: reserveLockerResponse?.data?.transaction_id,
                    is_already_opened_once: false,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name
                    },
                    locker_door: {
                        door_no: reserveLockerResponse?.data?.door_no
                    }
                };

                history.replace({
                    pathname: getPathForNextPage(LOCKER_UNIT_SELECTION, OPEN_LOCKER),
                    state: {
                        lockerUnitDetails
                    }
                });
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error while reserving locker: ', error);
        }
    };

    return (
        <div className='locker-unit-selection-page'>
            <div className='main-container'>
                {isLoading ? (
                    <div className='main'>
                        <CircularProgressLoader message={t('Reserving Locker. Please Wait.')} />
                    </div>
                ) : (
                    <div className='main'>
                        <h2 className='selected-locker-size'>{selectedLockerSize.name}</h2>
                        <div className='locker-unit-list'>
                            {selectedLockerSize?.free_doors.map((item, index) => (
                                <button
                                    className={(selectedLockerUnit.id === item.id) ? 'locker-unit selected-unit': 'locker-unit'}
                                    key={index}
                                    onClick={() => setSelectedLockerUnit(item)}
                                >
                                    Locker - {item.door_no}
                                </button>
                            ))}
                        </div>
                        <ButtonComponent
                            buttonId='reserve-locker'
                            title={selectedLockerUnit.id === null ? 'Reserve Locker' : `Reserve Locker - ${selectedLockerUnit.door_no}`}
                            disabled={selectedLockerUnit.id === null}
                            handleClick={reserveSelectedLocker}
                        />
                    </div>
                )}
                <CustomDialog
                    dialogId='user-proximity-error-modal'
                    dialogVisible={isUserProximityErrorModalVisible}
                    onClose={() => setIsUserProximityErrorModalVisible(false)}
                    handleCancel={() => setIsUserProximityErrorModalVisible(false)}
                    dialogTitle={t('Location Error')}
                    dialogContentText={userProximityError}
                    buttonOneTitle={t('Ok')}
                    buttonProps={{buttonOne: {type: BUTTON_PRIMARY}}}
                />
            </div>
        </div>
    );
};

export default LockerUnitSelectionPage;